import axios from '@axios'

/** 
* Índice
* {@link getLessons} - Obtener clases
* {@link getLesson} - Obtener clase
* {@link addLesson} - Crear clase
* {@link deleteLesson} - Eliminar clase
* {@link updateLesson} - Actualizar clase
*/

    /**
     * Obtener todads las clases
     * @param {*} queryParams 
     * @returns lessons 
     */
    export const getLessons = function (queryParams) {
        try {
            return new Promise((resolve, reject) => {
                axios
                    .get('/lessons', { params: queryParams })
                    .then(response => resolve(response))
                    .catch(error => reject(error))
            })

        } catch (error) {
            return error
        }
    }

    /**
     * Obtener clase
     * @param {integer} id ID de la clase 
     * @returns lesson
     */

    export const getLesson = function ( id ) {
        try {
            return new Promise((resolve, reject) => {
                axios
                    .get(`/lessons/${id}`)
                    .then(response => resolve(response))
                    .catch(error => reject(error))
            })

        } catch (error) {
            return error
        }
    }

    /**
     * Añadir clase
     * @param {*} data Datos del cliente 
     * @returns 
     */

    export const addLesson = function (data) {
        try {
            return new Promise((resolve, reject) => {
                axios
                    .post(`/lessons`, data)
                    .then(response => resolve(response))
                    .catch(error => reject(error))
            })

        } catch (error) {
            return error
        }
    }

    /**
     * Borrar clase
     * @param {integer} id ID de la clase a borrar
     * @returns 
     */

    export const deleteLesson = function ({ id }) {
        try {
            return new Promise((resolve, reject) => {
                axios
                    .delete(`/lessons/${id}`)
                    .then(response => resolve(response))
                    .catch(error => reject(error))
            })

        } catch (error) {
            return error
        }
    }

    /**
     * Actualizar clase
     * @param {integer} id ID de la clase a actualizar 
     * @returns 
     */

    export const updateLesson = function (data) {
        try {
            return new Promise((resolve, reject) => {
                axios
                    .put(`/lessons/${data.id}`, data)
                    .then(response => resolve(response))
                    .catch(error => reject(error))
            })

        } catch (error) {
            return error
        }
    }










